var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InicioCoordenador',{attrs:{"modo-diretor":"","periodo":_vm.periodo},on:{"carregando":function($event){return _vm.$emit('carregando', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }